import { Skeleton } from '@mantine/core';

export default function EditorPanelSkeleton() {
  return (
    <div className="relative h-full overflow-auto px-5 py-3">
      <Skeleton height={48} />
      <div className="mt-3 flex flex-col gap-3">
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
        <Skeleton height={60} />
      </div>
    </div>
  );
}
